(function () {
  'use strict';

  function initTermsPage() {
    var root = document.querySelector('#MainContent .gvfg-terms, .gvfg-terms-section-wrapper .gvfg-terms, #gvfgTermsPage');
    if (!root || root.dataset.gvfgTermsInit === '1') return;
    root.dataset.gvfgTermsInit = '1';
    root.classList.add('gvfg-terms--enhanced');

    var reveals = root.querySelectorAll('.gvfg-terms-reveal');
    function showReveal(el) {
      el.classList.add('is-visible');
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              showReveal(e.target);
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
      );
      reveals.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.92) showReveal(el);
        io.observe(el);
      });
    } else {
      reveals.forEach(showReveal);
    }
    setTimeout(function () {
      reveals.forEach(showReveal);
    }, 1200);

    var hero = root.querySelector('.gvfg-terms-hero');
    if (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-visible'); });
    }

    root.querySelectorAll('.gvfg-terms-3d-card').forEach(function (card) {
      var inner = card.querySelector('.gvfg-terms-3d-card__inner');
      if (!inner) return;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform =
          'rotateX(' + (-y * 14) + 'deg) rotateY(' + (x * 14) + 'deg) translateZ(12px)';
      });
      card.addEventListener('mouseleave', function () {
        inner.style.transform = '';
      });
    });

    root.querySelectorAll('.gvfg-terms-nav__pill').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        var id = pill.getAttribute('data-section');
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          root.querySelectorAll('.gvfg-terms-nav__pill').forEach(function (p) {
            p.classList.remove('is-active');
          });
          pill.classList.add('is-active');
        }
      });
    });

    root.querySelectorAll('.gvfg-terms-acc-item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        root.querySelectorAll('.gvfg-terms-acc-item[open]').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });

    root.querySelectorAll('a[href^="#gvfg-terms-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  window.gvfgInitTermsPage = function (force) {
    if (force) {
      document.querySelectorAll('.gvfg-terms').forEach(function (el) {
        delete el.dataset.gvfgTermsInit;
      });
    }
    initTermsPage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTermsPage);
  } else {
    initTermsPage();
  }

  document.addEventListener('shopify:section:load', initTermsPage);
})();